import React from "react";
import { IconContext } from "react-icons";
import { AiOutlineDisconnect } from "react-icons/ai";
import headlineImg from "../assets/images/headline_bg.svg";
import { motion } from "framer-motion";

const HeadLine = () => {
  return (
    <section className="headline-section" id="home" title="home">
      <div className="main-healine-container container">
        <div className="headline-left-container">
          <motion.h1
            initial={{ x: "100vh" }}
            animate={{ x: 10 }}
            transition={{ duration: 1.7 }}
            className="me"
          >
            I'm Moïse Glad to see you <span>!</span>
          </motion.h1>
          <motion.p
            initial={{ x: "100vh" }}
            animate={{ x: 10 }}
            transition={{ duration: 2 }}
            className="about-me"
          >
            Polyglot Staff Software Engineer with 8+ years building payment infrastructure, AI systems, and distributed platforms at scale.
            Led engineering at Yvy(Augustus), Cajeropay, and Layla.ai.
            Deep expertise in Java, TypeScript, Python, microservices, and high-volume fintech systems across Europe and beyond.
          </motion.p>
          <div className="connections">
            {/* <motion.a
              initial={{ y: 1000 }}
              animate={{ y: 10 }}
              download
              transition={{ duration: 2.5 }}
              href={resume}
              className="btn-resume"
            >
              Resume
            </motion.a> */}
            <motion.a
              initial={{ y: 1000 }}
              animate={{ y: 10 }}
              transition={{ duration: 3 }}
              className="connect"
              onClick={function () {
                window.open("https://linktr.ee/moiserushanika");
              }}
            >
              LET'S CONNECT
              <span>
                <IconContext.Provider value={{ className: "connect-icon" }}>
                  <AiOutlineDisconnect />
                </IconContext.Provider>
              </span>
            </motion.a>
          </div>
        </div>
        <motion.div
          initial={{ y: 1000 }}
          animate={{ y: 10 }}
          transition={{ duration: 3 }}
          className="headline-img"
        >
          <img src={headlineImg} alt="" />
        </motion.div>
      </div>
    </section>
  );
};

export default HeadLine;
